export class CalendlyFunctions {
  static calcDateDiffInHoursFromNow(dateA: Date): number {
    const diffInMs = Math.abs(new Date(dateA).valueOf() - new Date(Date.now()).valueOf());
    // convert ms to h
    return diffInMs / (60 * 60 * 1000);
  }
}
